import { render } from "./AboutUsView.vue?vue&type=template&id=2330b5fe&scoped=true"
import script from "./AboutUsView.vue?vue&type=script&lang=js"
export * from "./AboutUsView.vue?vue&type=script&lang=js"

import "./AboutUsView.vue?vue&type=style&index=0&id=2330b5fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2330b5fe"]])

export default __exports__